import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import moment from 'moment';
import { DoctorService } from '@/services/doctor.service';
import { REASSIGNMENT_DISABLED_IN_OPTIONS } from '@/constants/doctors';
import { REASSIGNMENT_TYPE } from '@/constants/ooo';
export default {
  data() {
    return {
      showDialog: false,
      doctorData: [],
      doctorOptions: [],
      selectedDoctor: '',
      selectedDoctorStates: '',
      alert: {
        show: false,
        message: ''
      },
      outFrom: '',
      outFromTime: '',
      outTo: '',
      outToTime: '',
      reassignmentOptions: [{
        text: 'Temporary',
        value: 'TEMPORARY'
      }, {
        text: 'Permanent',
        value: 'PERMANENT'
      }],
      indefinite: false,
      reassignmentType: '',
      doctorsByState: [],
      doctorsToReassign: [],
      fetchVersion: 0
    };
  },
  computed: {
    minDate() {
      return moment().format('YYYY-MM-DD');
    },
    fromMs() {
      if (!this.outFrom || !this.outFromTime) {
        return undefined;
      }
      return moment(`${this.outFrom} ${this.outFromTime}`, 'YYYY-MM-DD HH:mm:ss').valueOf();
    },
    toMs() {
      if (!this.outTo || !this.outToTime) {
        return undefined;
      }
      return moment(`${this.outTo} ${this.outToTime}`, 'YYYY-MM-DD HH:mm:ss').valueOf();
    },
    isFormValid() {
      const hasReassignTarget = this.doctorsToReassign.some(val => val !== null);
      const hasEndDate = this.indefinite || this.outTo && this.outToTime;
      return Boolean(this.reassignmentType && this.selectedDoctor && this.outFrom && this.outFromTime && hasEndDate && hasReassignTarget);
    }
  },
  watch: {
    async showDialog(show) {
      if (show) {
        const {
          data
        } = await DoctorService.getAllDoctorsV2();
        this.doctorData = data;
        for (const doctor of data) {
          this.doctorOptions.push({
            value: doctor.id,
            text: `Dr. ${doctor.firstname} ${doctor.lastname}`
          });
        }
      } else {
        this.doctorOptions = [];
        this.doctorsToReassign = [];
        this.doctorsByState = [];
        this.reassignmentType = '';
        this.outFrom = '';
        this.outTo = '';
        this.indefinite = false;
        this.alert.show = false;
        this.selectedDoctorStates = '';
        this.selectedDoctor = '';
        this.outFromTime = '';
        this.outToTime = '';
      }
    },
    async reassignmentType(type) {
      this.indefinite = type == 'PERMANENT';
      await this.fetchDoctorsByState({
        preserveSelection: false
      });
    },
    async selectedDoctor() {
      this.doctorsByState = [];
      this.doctorsToReassign = [];
      const selectedDoctor = this.doctorData.find(o => o.id == this.selectedDoctor);
      this.selectedDoctorStates = this.getStates(selectedDoctor, false);
      await this.fetchDoctorsByState({
        preserveSelection: false
      });
    },
    async toMs() {
      await this.refreshDoctorList();
    },
    async fromMs() {
      await this.refreshDoctorList();
    }
  },
  methods: {
    showAlert(msg) {
      this.alert.message = msg;
      this.alert.show = true;
    },
    getStates(doctor, abbrev = true) {
      if (!doctor || !doctor.coveredstate || !doctor.coveredstate.length) {
        return '';
      }
      let str = '';
      for (const state of doctor.coveredstate) {
        str += `${state.state}, `;
      }
      if (abbrev) {
        return str.substr(0, str.length - 2);
      } else {
        return `State(s): ${str.substr(0, str.length - 2)}`;
      }
    },
    getMatchingStates(doctor) {
      if (!this.selectedDoctor || !doctor || !doctor.coveredstate || !doctor.coveredstate.length) {
        return '';
      }
      const selectedDoctor = this.doctorData.find(d => d.id == this.selectedDoctor);
      if (!selectedDoctor || !selectedDoctor.coveredstate || !selectedDoctor.coveredstate.length) {
        return '';
      }
      const selectedDoctorStates = selectedDoctor.coveredstate.map(cs => cs.state);
      const matchingStates = doctor.coveredstate.filter(cs => selectedDoctorStates.includes(cs.state)).map(cs => cs.state);
      return matchingStates.join(', ');
    },
    getSecondsFromTime(time) {
      const timeArray = time.split(':');
      const hours = timeArray[0];
      const minutes = timeArray[1];
      const secondsInHours = Number(hours) * 60 * 60;
      const secondsInMinutes = Number(minutes) * 60;
      return secondsInHours + secondsInMinutes;
    },
    async addReassignment() {
      try {
        this.alert.show = false;
        if (!this.reassignmentType || !this.selectedDoctor || !this.outTo && this.reassignmentType == 'TEMPORARY' || !this.outToTime && this.reassignmentType == 'TEMPORARY' || !this.outFrom || !this.outFromTime) {
          this.showAlert('Please fill in all the fields.');
          return;
        }
        const outFrom = Math.round(moment(this.outFrom).format('X')) + this.getSecondsFromTime(this.outFromTime);
        const outTo = Math.round(moment(this.outTo).format('X')) + this.getSecondsFromTime(this.outToTime);
        const doctorlist = this.doctorsToReassign.filter(function (val) {
          return val !== null;
        });
        if (!doctorlist || doctorlist.length == 0) {
          this.showAlert('Please select at least one doctor to reassign to.');
          return;
        }
        const body = {
          startdatestamp: outFrom,
          doctorid: this.selectedDoctor,
          doctorlist,
          assignmenttype: this.reassignmentType
        };
        if (!this.indefinite) {
          body['enddatestamp'] = outTo;
        }
        const {
          data
        } = await DoctorService.addReassignment(body);
        if (data) {
          this.$emit('add-row', data);
          this.showDialog = false;
        }
      } catch (err) {
        this.showAlert(err);
      }
    },
    refreshDoctorList() {
      return this.fetchDoctorsByState({
        preserveSelection: true
      });
    },
    async fetchDoctorsByState({
      preserveSelection
    }) {
      const selectedDoctor = this.doctorData.find(o => o.id == this.selectedDoctor);
      if (!selectedDoctor || !this.reassignmentType) {
        return;
      }
      this.fetchVersion += 1;
      const version = this.fetchVersion;
      const previouslySelected = preserveSelection ? new Set(this.doctorsToReassign.filter(id => id != null)) : new Set();
      const states = selectedDoctor.coveredstate.map(({
        state
      }) => state);
      const {
        data
      } = await DoctorService.getDoctorsByStateV2(states, this.toMs, this.fromMs, REASSIGNMENT_DISABLED_IN_OPTIONS.OOO, this.reassignmentType);
      if (version !== this.fetchVersion) {
        return;
      }
      const docToRemove = this.selectedDoctor;
      this.doctorsByState = data.filter(val => {
        var _val$reassignment_dis, _val$reassignment_dis2;
        return val.id !== docToRemove && (val.override_reassignment_rule || !((_val$reassignment_dis = val.reassignment_disabled_in) !== null && _val$reassignment_dis !== void 0 && _val$reassignment_dis.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.OOO)) && (this.reassignmentType !== REASSIGNMENT_TYPE.PERMANENT || !((_val$reassignment_dis2 = val.reassignment_disabled_in) !== null && _val$reassignment_dis2 !== void 0 && _val$reassignment_dis2.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.PERMANENT_REASSIGNMENT))));
      });
      this.doctorsToReassign = this.doctorsByState.map(doctor => previouslySelected.has(doctor.id) ? doctor.id : null);
    }
  }
};